// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"LoadingSpinner_loadingSpinner__00vCi"};